import React from 'react';

const Headline = ({title}) => {

  return (
    <section className="headline">
      <div className="headline__inner">
        <h1>{title}</h1>
      </div>
    </section>
  );
}

export default Headline